import apiClient from './apiClient';

export interface NotificationListItem {
  id: string;
  notificationType: string;
  title: string;
  message: string;
  priority: 'normal' | 'high' | 'urgent';
  deliveryMethod: 'in_app' | 'push' | 'whatsapp' | 'telegram' | 'email' | 'sms';
  deliveryStatus: 'pending' | 'sent' | 'delivered' | 'failed';
  deliveryError: string | null;
  isRead: boolean;
  isEscalation: boolean;
  escalationLevel: number;
  readAt: string | null;
  sentAt: string | null;
  expiresAt: string | null;
  createdAt: string;
  recipientUserId: string;
  recipientUserName: string | null;
  recipientTeamId: string | null;
  relatedTaskId: string | null;
  relatedTaskCode: string | null;
}

export interface NotificationsCenter {
  notifications: NotificationListItem[];
  totals: {
    count: number;
    unread: number;
    high: number;
    urgent: number;
    failed: number;
    byType: Record<string, number>;
  };
}

export interface NotificationFilters {
  type?: string;
  priority?: 'all' | 'normal' | 'high' | 'urgent';
  readState?: 'all' | 'read' | 'unread';
  allUsers?: boolean;
  limit?: number;
}

class NotificationService {
  async getCenter(filters: NotificationFilters = {}): Promise<NotificationsCenter> {
    const params: Record<string, string> = {};
    if (filters.type && filters.type !== 'all') params.type = filters.type;
    if (filters.priority && filters.priority !== 'all') params.priority = filters.priority;
    if (filters.readState && filters.readState !== 'all') params.readState = filters.readState;
    if (filters.allUsers) params.allUsers = 'true';
    if (filters.limit) params.limit = String(filters.limit);
    const response: any = await apiClient.get('/notifications', { params });
    return response.data;
  }

  async markAsRead(id: string): Promise<void> {
    await apiClient.post(`/notifications/${id}/read`);
  }

  async markAllAsRead(): Promise<number> {
    const response: any = await apiClient.post('/notifications/mark-all-read');
    return response.data?.updated ?? 0;
  }

  async getVapidPublicKey(): Promise<string | null> {
    const response: any = await apiClient.get('/notifications/vapid-public-key');
    return response.data?.publicKey ?? null;
  }

  async savePushSubscription(subscription: PushSubscriptionJSON): Promise<void> {
    await apiClient.post('/notifications/push-subscriptions', subscription);
  }

  async deletePushSubscription(endpoint: string): Promise<void> {
    await apiClient.delete('/notifications/push-subscriptions', { data: { endpoint } });
  }
}

export default new NotificationService();
